import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IGertUserListResponse,
  IPayslipOverviewResponse,
} from "@/interface/payslip.interface";

export const PayslipService = {
  getOverview: async (
    queryString: string,
  ): Promise<IPayslipOverviewResponse> => {
    return callApi<IPayslipOverviewResponse>(
      `${API_ENDPOINT.userMonthlySalaryOverview}?${queryString}`,
      { method: "GET" },
    );
  },

  getList: async (queryString: string): Promise<IGertUserListResponse> => {
    return callApi<IGertUserListResponse>(
      `${API_ENDPOINT.getMonthlyUserSalaryList}?${queryString}`,
      { method: "GET" },
    );
  },

  generatePayslip: async (
    userId: string,
    startDate: string,
    endDate: string,
  ): Promise<ArrayBuffer> => {
    const API = `${API_ENDPOINT.generateSalarySlip}?userId=${userId}&startDate=${startDate}&endDate=${endDate}&_=${Date.now()}`;
    return callApi<ArrayBuffer>(API, {
      method: "GET",
      cache: "no-store", // force fresh request
    });
  },
};
